/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ActualizarPreguntaME } from '../model/actualizarPreguntaME';
import { AdicionarPreguntaME } from '../model/adicionarPreguntaME';
import { BorrarPreguntaME } from '../model/borrarPreguntaME';
import { CambiarPreguntaME } from '../model/cambiarPreguntaME';
import { CambiarPreguntaMS } from '../model/cambiarPreguntaMS';
import { ObtenerListaPreguntaMS } from '../model/obtenerListaPreguntaMS';
import { ObtenerListaPreguntaPorEstadoMS } from '../model/obtenerListaPreguntaPorEstadoMS';
import { ObtenerListaRegistroMS } from '../model/obtenerListaRegistroMS';
import { ObtenerUnaPreguntaME } from '../model/obtenerUnaPreguntaME';
import { ObtenerUnaPreguntaMS } from '../model/obtenerUnaPreguntaMS';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PreguntaService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10PreguntaActualizarPreguntaPost(body?: ActualizarPreguntaME, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiV10PreguntaActualizarPreguntaPost(body?: ActualizarPreguntaME, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiV10PreguntaActualizarPreguntaPost(body?: ActualizarPreguntaME, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiV10PreguntaActualizarPreguntaPost(body?: ActualizarPreguntaME, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/v1.0/Pregunta/ActualizarPregunta`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10PreguntaBorrarPost(body?: BorrarPreguntaME, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiV10PreguntaBorrarPost(body?: BorrarPreguntaME, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiV10PreguntaBorrarPost(body?: BorrarPreguntaME, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiV10PreguntaBorrarPost(body?: BorrarPreguntaME, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/v1.0/Pregunta/Borrar`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10PreguntaCambiarPost(body?: CambiarPreguntaME, observe?: 'body', reportProgress?: boolean): Observable<CambiarPreguntaMS>;
    public apiV10PreguntaCambiarPost(body?: CambiarPreguntaME, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CambiarPreguntaMS>>;
    public apiV10PreguntaCambiarPost(body?: CambiarPreguntaME, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CambiarPreguntaMS>>;
    public apiV10PreguntaCambiarPost(body?: CambiarPreguntaME, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CambiarPreguntaMS>('post',`${this.basePath}/api/v1.0/Pregunta/Cambiar`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10PreguntaGet(observe?: 'body', reportProgress?: boolean): Observable<ObtenerListaPreguntaMS>;
    public apiV10PreguntaGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ObtenerListaPreguntaMS>>;
    public apiV10PreguntaGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ObtenerListaPreguntaMS>>;
    public apiV10PreguntaGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ObtenerListaPreguntaMS>('get',`${this.basePath}/api/v1.0/Pregunta`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10PreguntaListarPorEstadoGet(observe?: 'body', reportProgress?: boolean): Observable<ObtenerListaPreguntaPorEstadoMS>;
    public apiV10PreguntaListarPorEstadoGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ObtenerListaPreguntaPorEstadoMS>>;
    public apiV10PreguntaListarPorEstadoGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ObtenerListaPreguntaPorEstadoMS>>;
    public apiV10PreguntaListarPorEstadoGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ObtenerListaPreguntaPorEstadoMS>('get',`${this.basePath}/api/v1.0/Pregunta/ListarPorEstado`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10PreguntaObtenerAleatoriasGet(observe?: 'body', reportProgress?: boolean): Observable<ObtenerListaRegistroMS>;
    public apiV10PreguntaObtenerAleatoriasGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ObtenerListaRegistroMS>>;
    public apiV10PreguntaObtenerAleatoriasGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ObtenerListaRegistroMS>>;
    public apiV10PreguntaObtenerAleatoriasGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ObtenerListaRegistroMS>('get',`${this.basePath}/api/v1.0/Pregunta/ObtenerAleatorias`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10PreguntaObtenerUnaPost(body?: ObtenerUnaPreguntaME, observe?: 'body', reportProgress?: boolean): Observable<ObtenerUnaPreguntaMS>;
    public apiV10PreguntaObtenerUnaPost(body?: ObtenerUnaPreguntaME, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ObtenerUnaPreguntaMS>>;
    public apiV10PreguntaObtenerUnaPost(body?: ObtenerUnaPreguntaME, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ObtenerUnaPreguntaMS>>;
    public apiV10PreguntaObtenerUnaPost(body?: ObtenerUnaPreguntaME, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ObtenerUnaPreguntaMS>('post',`${this.basePath}/api/v1.0/Pregunta/ObtenerUna`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10PreguntaPost(body?: AdicionarPreguntaME, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiV10PreguntaPost(body?: AdicionarPreguntaME, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiV10PreguntaPost(body?: AdicionarPreguntaME, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiV10PreguntaPost(body?: AdicionarPreguntaME, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/v1.0/Pregunta`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
